/* import __COLOCATED_TEMPLATE__ from './attachment.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();